import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { LoginExceptions } from '@commoncore/exception/LoginExceptions';
import { CleverTapEventsService, ScreenNames } from '@commoncore/services/clevertap-events-service';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { PasswordEncryptorUtil } from '@mainrepo/app/core/utils/PasswordEncryptorUtil';


export class TwoFactorImplementation {
    public router: any;
    public http: any;
    public route: any;
    public universalService: any;
    contextMenuService: any;
    static singleInstance:TwoFactorImplementation
    public exception: any;
    public requestId2FA:any
    public mobileNumber2FA:any
    public email2FA:any

    //public hashAtPhrasePasswordReset:any
    public encTwoFASessionKey:any
    public sessionKey:any
    public disableError:boolean = false

    passwordEncryptorUtil:PasswordEncryptorUtil
    localStorageSvc: LocalStorageSvc;
    sessionStorageService: any;
    cleverTapEventsService:CleverTapEventsService
  
    constructor(public globalService:GlobalService) {
      this.setHandler(globalService)
      this.exception = new LoginExceptions(globalService);

      this.passwordEncryptorUtil=new PasswordEncryptorUtil();

    }
  
    public setHandler(globalService) {
      this.router = globalService.getRouterRef();
      this.http = globalService.getHttpClientRef();
      this.universalService = globalService.getUniversalServiceRef();
      this.route = globalService.getActivatedRoute();
      this.contextMenuService = globalService.getContextMenuServiceRef();
      this.localStorageSvc = globalService.getLocalStorageSvcRef();
      this.sessionStorageService = globalService.getSessionStorageSvcRef();
      this.cleverTapEventsService = this.globalService.getCleverTapEventsvc();
      
    }
  
    
    public static getInstance(globalService):TwoFactorImplementation{
      if(this.singleInstance == null){
        this.singleInstance = new TwoFactorImplementation(globalService);
        return this.singleInstance;
      }else{
        return this.singleInstance;
      }
    }
   
   sendOTP(passPhrase,resend=false){
     
    const serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["pbsURL"]+  ENV_CONFIG.commonUrls["sendotp2fa"];
    var self = this
      return new Promise(function(resolve, reject){
        self.http.get(serviceUrl).subscribe(
          (suc) => { 
            self.universalService.showLoader = false;

            self.cleverTapEventsService.passphraseScreenViewed('Enter OTP passphrase');
            self.mobileNumber2FA = suc['mobileNumber'];
            self.email2FA = suc['emailId'];
            self.requestId2FA = suc['requestId'];
            if(self.mobileNumber2FA!=undefined && self.email2FA!=undefined){
              self.universalService.otpReceivedOn = self.mobileNumber2FA+" & "+self.email2FA;
              if(resend)
                self.universalService.showToast(TOAST["OTP_SENT_SUCCESSFULLY_BOTH"], "success")
            }else if(self.mobileNumber2FA==undefined && self.email2FA!=undefined){
              self.universalService.otpReceivedOn = " "+self.email2FA;
              if(resend)
                self.universalService.showToast(TOAST["OTP_SENT_SUCCESSFULLY"], "success")
            }else if(self.mobileNumber2FA!=undefined && self.email2FA==undefined){
              self.universalService.otpReceivedOn = " "+self.mobileNumber2FA;
              if(resend)
                self.universalService.showToast(TOAST["OTP_SENT_SUCCESSFULLY_MOBILE"], "success")
              
            }

            self.get2FAHash(passPhrase)
            self.universalService.showPassPhraseReset = false;
            AppEvents.globalObservable.next({"otpverificationrequired":true,"source":self.universalService.otpReceivedOn,moduleType:"twofa"});
            resolve(suc)
          },
          (error) => {
            self.universalService.showLoader = false;
            console.log("error from send OTP",error);
            resolve(error)
          },
        );
      })
    }

    get2FAHash(passPhrase){
      var userData = this.localStorageSvc.getUserData(true);
      //this.universalService.twoFAHash = this.passwordEncryptorUtil.getHash(this.localStorageSvc.getUserId(true),passPhrase);////userId,passPhrase
      this.universalService.twoFAHash = this.passwordEncryptorUtil.getHash(userData["userId"],passPhrase);////userId,passPhrase
    }
   
    async enable2FA(otp){
      var userData = this.localStorageSvc.getUserData(true);
      //let StringToEncrypt = this.localStorageSvc.getUserId(true)+"#"+this.universalService.twoFAHash
      let StringToEncrypt = userData["userId"]+"#"+this.universalService.twoFAHash
      let encTwoFAHash = await this.passwordEncryptorUtil.encryptPassPhrase(StringToEncrypt, otp)
      const serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]+  ENV_CONFIG.commonUrls["enable2fa"];
      let params = {
        'requestId': this.requestId2FA,
        'encTwoFAHash': encTwoFAHash,
      };
      var self = this
        return new Promise(function(resolve, reject){  
          self.http.post(serviceUrl, params).subscribe(
            async (suc) => { 
              self.universalService.showLoader = false;
              AppEvents.globalObservable.next({"otpverificationrequired":false});
              self.encTwoFASessionKey =  suc['encTwoFASessionKey'];
            
              AppEvents.updateAuthData.next({"updateProperty":true,"property":{"key":"encTwoFASessionKey","value":suc['encTwoFASessionKey']}})
              self.localStorageSvc.setTwoFAEnable("Y",true);
              if(self.universalService.isPassphraseReset){
                self.universalService.showToast(TOAST["PASSPHRASE_RESET_SUCCESS"], "success");
              }else{
                self.universalService.showToast(TOAST["PASSPHRASE_SET_SUCCESS"], "success");

              }
              self.universalService.isPassphraseReset = false
              
              self.universalService.tempPassPhrase = "";
              AppEvents.optionSelected.next({enable2FA: true});
              if(self.router.url == ('/') || self.router.url == ('/signin')){
                self.cleverTapEventsService.passPhraseReset(ScreenNames.forgotPassPhrase);
                self.redirectionAfterForgotPassPhrase();

              }else{
                self.cleverTapEventsService.passPhraseReset(ScreenNames.resetPassPhrase);
                self.universalService.show2FApopUp = false;
                self.universalService.showLoader = false;
                localStorage.setItem("passPhraseValidationSuccess", 'true')
                var route = sessionStorage.getItem('redirectedRoute')
                if(route != undefined && route != null){
                  sessionStorage.removeItem('redirectedRoute')
                  self.globalService.getRouterRef().navigate([route])
                }
              }
              self.universalService.disableModalBackdrop();
              //self.disable2FA("");//to test disable
               resolve(suc)
            },
            (error) => {
              self.universalService.showLoader = false;
              self.exception.handleLoginError('OTP',error);
              AppEvents.globalObservable.next({"otpverificationerror":true,"message":self.exception.errorMessage});
              setTimeout(function() {
                (<HTMLInputElement>document.getElementById("digit1")).focus();
                }, 500);
              if(self.localStorageSvc.getTwoFAEnable(true) == "Y"){
                AppEvents.optionSelected.next({enable2FA: true});
              }else{
                AppEvents.optionSelected.next({enable2FA: false});
              }

              reject(error)
            },
          );
        })
    }

    redirectionAfterForgotPassPhrase(){
      localStorage.setItem('passPhraseValidationSuccess','true')
      var shareKey = this.sessionStorageService.getShareKey()
      var grantAccessUrl = this.sessionStorageService.getGrantAccessId();
      var singleObjectShared = this.sessionStorageService.getSingleSharedObject(true);
      if (shareKey != "" && shareKey) {
        var link = '/share/?s=' + shareKey;
        window.open(link, "_self", "noopener, noreferrer");
      } else {
        if (grantAccessUrl) {
          window.open(grantAccessUrl, "_self", "noopener, noreferrer");
        } else if (singleObjectShared != "") {
          if (this.universalService.activeRepo == 'main') {
            this.globalService.getRouterRef().navigate(['shared/sharedwithme']);
          } else {
            window.location.href = '/shared/sharedwithme'
          }
          this.universalService.setAnimationStatus('Shared');
        } else {
          if (this.universalService.activeRepo == 'main') {
            this.globalService.getRouterRef().navigate(['home']);
          } else {
            window.location.href = '/home'
          }
        }
      }
    }
    async disable2FA(passPhrase){ 
      const d=new Date()
      var userData = this.localStorageSvc.getUserData(true);
      //let StringToEncrypt = this.localStorageSvc.getUserId(true)+"#"+this.universalService.twoFAHash+"#"+d.getTime();      
      let StringToEncrypt = userData["userId"]+"#"+this.universalService.twoFAHash+"#"+d.getTime();      
      let decyrptencTwoFASessionKey = await this.passwordEncryptorUtil.decryptTwoFASessionKey(userData["encTwoFASessionKey"], this.universalService.twoFAHash)
     
      if(decyrptencTwoFASessionKey.length == 0){
        this.universalService.showLoader = false;
        this.disableError =true

        return false;
      }else{
        this.disableError = false
      }
      this.universalService.enc2FAHash = await this.passwordEncryptorUtil.encryptPassPhrase(StringToEncrypt, decyrptencTwoFASessionKey.split("#")[1])
      //this.universalService.enc2FAHash = await this.passwordEncryptorUtil.encryptPassPhrase_new(StringToEncrypt,decyrptencTwoFASessionKey.split("#")[1])
      console.log(" this.universalService.enc2FAHash::",this.universalService.enc2FAHash)
      const serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]+  ENV_CONFIG.commonUrls["disable2fa"];
      var self = this
       // return new Promise(function(resolve, reject){
          self.http.put(serviceUrl).subscribe(
            async (suc) => { 
              self.universalService.showLoader = false;
              this.disableError =false
              self.localStorageSvc.setTwoFAEnable("N",true);
              AppEvents.updateAuthData.next({"removeProperty":true,"property":{"key":"encTwoFASessionKey"}})
              self.universalService.isDisable2FAInprocess = false
              self.universalService.showToast(TOAST["PASSPHRASE_DISABLED_SUCCESS"], "success");

              localStorage.removeItem("passPhraseValidationSuccess");
              AppEvents.optionSelected.next({enable2FA: false});
              return true;
             //  resolve(suc)
            },
            (error) => {
              self.universalService.showLoader = false;
              this.disableError =true

              return false;
            },
          );
        //})
    }


    close2FAOTP(){      
      this.universalService.isPassphraseReset = false;
      var enable2FA = this.localStorageSvc.getTwoFAEnable(true)
      if(this.universalService.forgotPassPhraseModalOpned){
        this.universalService.forgotPassPhraseModalOpned = false;
        this.universalService.show2FApopUp = true;
      }else{
        this.universalService.disableModalBackdrop();
        $('#custome_backdrop').remove();
        if(enable2FA == "Y"){
          if(!this.universalService.forgotPassPhraseModalOpned){
            this.universalService.show2FApopUp = false;
          }
          AppEvents.optionSelected.next({enable2FA: true});
        }else if(enable2FA == "N"){
          AppEvents.optionSelected.next({enable2FA: false});
        }
      }
    }


  }
  